<template>
    <div class="relative" v-click-outside="close">
        <div @click="toggle" class="cursor-pointer relative">
            <svg-icon icon="bell-fill" :class="{'w-5 h-5': bottom, 'w-5 h-5 text-orange': !bottom}"></svg-icon>
            <div v-if="unread"
                 class="absolute rounded flex items-center justify-center w-4 h-4 -top-2 -right-2 leading-none p-0.5 text-xxs font-medium text-white bg-red-500">
                {{ unread >= 10 ? '9+' : unread }}
            </div>
        </div>
        <div v-if="opened"
             class="fixed overflow-hidden top-16 left-0 md:left-auto right-0 md:bottom-auto mx-auto md:absolute md:rounded md:border md:border-gray-200 dark:md:border-slate-700 bg-white dark:bg-slate-800 dark:text-white p-2 md:w-80 card-white md:top-full md:translate-y-3 md:right-0 bottom-[calc(48px+env(safe-area-inset-bottom))] z-80"
        >
            <div class="flex space-x-4 items-center justify-between pb-2">
                <div class="font-medium px-2 md:px-0">Уведомления</div>
                <div v-if="unread" @click="markAllRead(false)"
                     class="text-xs cursor-pointer text-blue-500 dark:text-blue-300">
                    Пометить как прочитанные
                </div>
            </div>
            <div
                class="md:text-sm pb-10 md:pb-0 h-[calc(100%-32px)] md:h-80 overflow-x-hidden overflow-y-scroll no-scroll">
                <div v-if="!loading && (!notifications || !notifications.length)"
                     class="text-gray-500 text-center p-2">
                    Уведомлений нет
                </div>
                <div v-if="notifications">
                    <div v-if="loading" class="text-gray-500 dark:text-gray-300 text-center p-2">
                        Ищу твои уведомления
                    </div>
                    <div v-else class="space-y-0.5">
                        <a @click.prevent="processLink(noty, $event)" v-for="noty in notifications"
                           :href="noty.data.url"
                           class="block p-2 md:text-sm rounded" :class="{'bg-blue-50 dark:bg-slate-600' : !noty.read}"
                        >
                            <div class="flex items-start space-x-2">
                                <div class="w-6 h-6 shrink-0">
                                    <div v-if="noty.type === 'subscriber_added'"
                                         class="rounded-full flex items-center justify-center w-6 h-6 bg-blue-500 text-white">
                                        <svg-icon icon="check-circle-fill" class="w-3 h-3"></svg-icon>
                                    </div>
                                    <div v-if="noty.type === 'comment_reply'|| noty.type === 'post_comment'"
                                         class="rounded-full flex items-center justify-center w-6 h-6 bg-blue-500 text-white">
                                        <svg-icon icon="reply-fill" class="w-3 h-3"></svg-icon>
                                    </div>
                                    <div v-if="noty.type === 'user_mentioned'"
                                         class="rounded-full flex items-center justify-center w-6 h-6 bg-yellow-400 text-white">
                                        <svg-icon icon="at" class="w-3 h-3"></svg-icon>
                                    </div>
                                    <div
                                        v-if="(noty.type === 'comment_like' || noty.type === 'post_like' ) && noty.data.rate < 0"
                                        class="rounded-full flex items-center justify-center w-6 h-6 bg-red-500 text-white">
                                        <svg-icon icon="chevron-down" class="w-3 h-3"></svg-icon>
                                    </div>
                                    <div
                                        v-if="(noty.type === 'comment_like' || noty.type === 'post_like' ) && noty.data.rate > 0"
                                        class="rounded-full flex items-center justify-center w-6 h-6 bg-green-500 text-white">
                                        <svg-icon icon="chevron-up" class="w-3 h-3"></svg-icon>
                                    </div>
                                    <div v-if="noty.type === 'post_reply'"
                                         class="rounded-full flex items-center justify-center w-6 h-6 bg-purple-500 text-white">
                                        <svg-icon icon="chat-left-text-fill" class="w-3 h-3"></svg-icon>
                                    </div>
									<div v-if="noty.type === 'post_published'"
										 class="rounded-full flex items-center justify-center w-6 h-6 bg-blue-500 text-white">
										<svg-icon icon="app-indicator" class="w-3 h-3"></svg-icon>
									</div>
                                    <div v-if="noty.type === 'post_unpublished'"
                                         class="rounded-full flex items-center justify-center w-6 h-6 bg-red-500 text-white">
                                        <svg-icon icon="emoji-frown" class="w-3 h-3"></svg-icon>
                                    </div>

                                    <div v-if="noty.type === 'post_complained'
                                    || noty.type === 'post_moved'
                                    || noty.type === 'comment_complained'
                                    || noty.type === 'user_banned'
                                    || noty.type === 'user_warned'
                                        "
                                         class="rounded-full flex items-center justify-center w-6 h-6 bg-red-500 text-white">
                                        <svg-icon icon="exclamation-circle-fill" class="w-3 h-3"></svg-icon>
                                    </div>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div v-html="noty.message ?? noty.data.message"
                                         class="w-full max-w-full text-sm md:text-xs text-black dark:text-white break-words min-w-0"></div>
                                    <smartdate class="text-xs text-gray-500 dark:text-gray-300"
                                               :date="noty.date"></smartdate>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import User from "../../js/modules/User";
import Urls from "../../js/modules/Urls";
import CommentScroller from "../../js/modules/CommentScroller";
import {NotificationStore} from "../../js/stores/NotificationStore";

export default {
    props: [
        'count',
        'bottom',
    ],
    data() {
        let currentUser = new User();

        let markRead = currentUser.check()
            ? currentUser.data().settings.notifications?.settings?.mark_as_read
            : false;

        return {
            opened: false,
            user: currentUser,
            markRead: markRead,
            store: new NotificationStore(),
        };
    },
    mounted() {
        this.store.setUnread(this.count);
        this.store.fetchNotifications();
        this.store.enableSockets();
    },
    computed: {
        notifications() {
			const notifications = this.store.getNotifications;

			return notifications.sort((a, b) => {
				// Сначала сортируем по read: 0 перед 1
				if (a.read !== b.read) {
					return a.read - b.read; // read === false будет перед read === false
				}
				// Если read одинаковый, оставляем исходный порядок по дате
				return new Date(b.date) - new Date(a.date);
			})
		},
        unread() {
            return this.store.getUnread;
        },
        loading() {
            return this.store.getLoading;
        }
    },
    methods: {
        close() {
            this.opened = false;
        },
        toggle() {
            this.opened = !this.opened;

            if (this.opened) {
                if (this.markRead) {
                    this.markAllRead(true);
                }
            }
        },
        processLink(noty) {
            noty.read = true;

            Client.post('/api/v1.1/notifications/' + noty.id + '/read')
                .then(response => {
                    let baseUrl = Urls.baseUrl(window.location.href);
                    let isLinkToCurrentPagePost = noty.data.url === baseUrl;
                    let hash = Urls.hash(noty.data.url);
                    let commentElement = hash ? document.querySelector('#' + hash) : null;

                    // Если в уведомлении стоит ссылка на текущий пост, но без якоря, то прокручиваем к началу страницы
                    if (isLinkToCurrentPagePost) {
                        window.scrollTo(0, 0);
                        window.history.pushState({}, "", noty.data.url);
                    } else {
                        if (commentElement) {
                            CommentScroller(commentElement);
                        } else {
                            window.location.href = noty.data.url;
                        }
                    }
                })
                .catch(error => {
                });

            let unread = this.store.getUnread;

            if (unread) {
                this.store.setUnread(unread - 1);
            }

            this.opened = false;
        },
        markAllRead(silent = false) {
            Client.post('/api/v1.1/notifications/read');

            if (!silent) {
                this.notifications = this.notifications.map(noty => {
                    noty.read = true;
                    return noty;
                })
            }

            this.store.setUnread(0);
        }
    }
}
</script>
